import { render } from "./SfFaq.vue?vue&type=template&id=f6482dfc&ts=true"
import script from "./SfFaq.vue?vue&type=script&lang=ts"
export * from "./SfFaq.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__